<template>
  <div class="cols">
    <h2>{{ $t('settings.car-fleet.title-manage-devices') }}</h2>
    <ManageCarFleet :search-token="searchToken"/>
  </div>
</template>

<script>
import ManageCarFleet from '@/components/pages/carfleet/ManageCarFleet';

export default {
  components: {
    ManageCarFleet,
  },
  name: 'CarFleet',
  props: {
    searchToken: String,
  },
};
</script>
